<template>
  <div class="bag__form container cart-skeleton" aria-hidden="true">
    <h2 class="bag__title">
      <span class="skeleton skeleton--text cart-skeleton__title"></span>
    </h2>
    <div class="bag__content">
      <section class="bag__summary">
        <div class="bag__summary-inner">
          <div class="bag__totals">
            <div class="bag__summary-header">
              <h2 class="bag__summary-title">
                <span class="skeleton skeleton--text cart-skeleton__summary-title"></span>
              </h2>
            </div>
            <div class="bag__summary-totals">
              <p class="bag__total">
                <span class="skeleton skeleton--text cart-skeleton__total-label"></span>
                <span class="skeleton skeleton--text cart-skeleton__total-value"></span>
              </p>
              <p class="bag__total">
                <span class="skeleton skeleton--text cart-skeleton__total-label"></span>
                <span class="skeleton skeleton--text cart-skeleton__total-value"></span>
              </p>
              <p class="bag__total">
                <span class="skeleton skeleton--text cart-skeleton__total-label"></span>
                <span class="skeleton skeleton--text cart-skeleton__total-value"></span>
              </p>
              <div class="bag__final-total">
                <h3 class="bag__total bag__total--cart-total">
                  <span class="skeleton skeleton--text cart-skeleton__total-label"></span>
                  <span class="skeleton skeleton--text cart-skeleton__total-value"></span>
                </h3>
              </div>
            </div>
          </div>
        </div>
        <div class="bag__actions">
          <span class="skeleton cart-skeleton__checkout"></span>
        </div>
        <div class="bag__cart-tout">
          <div class="bag__cart-tout-image">
            <span class="skeleton skeleton--circle cart-skeleton__tout-icon"></span>
          </div>
          <span class="bag__cart-tout-text">
            <span class="skeleton skeleton--text cart-skeleton__tout-text"></span>
          </span>
        </div>
      </section>
      <section class="bag__items">
        <article class="bag-item">
          <div class="bag-item__wrapper">
            <div class="bag-item__photo">
              <span class="skeleton cart-skeleton__photo"></span>
            </div>
            <header class="bag-item__header--mobile mobile-only">
              <h4 class="bag-item__title">
                <span class="skeleton skeleton--text cart-skeleton__item-title"></span>
              </h4>
              <p class="bag-item__price">
                <span class="skeleton skeleton--text cart-skeleton__item-price"></span>
              </p>
            </header>
            <div class="bag-item__info">
              <div class="bag-item__desc">
                <header class="bag-item__header desktop-only">
                  <h4 class="bag-item__title">
                    <span class="skeleton skeleton--text cart-skeleton__item-title"></span>
                  </h4>
                  <p class="bag-item__price">
                    <span class="skeleton skeleton--text cart-skeleton__item-price"></span>
                  </p>
                </header>
                <div class="bag-item__accordion">
                  <div class="bag-item__accordion-wrapper">
                    <ul class="bag-item__accordion-fields list-reset">
                      <li class="bag-item__accordion-field">
                        <p class="bag-item__accordion-value">
                          <span class="skeleton skeleton--text cart-skeleton__detail-label"></span>
                        </p>
                        <p class="bag-item__accordion-value">
                          <span class="skeleton skeleton--text cart-skeleton__detail-value"></span>
                        </p>
                      </li>
                      <li class="bag-item__accordion-field">
                        <p class="bag-item__accordion-value">
                          <span class="skeleton skeleton--text cart-skeleton__detail-label"></span>
                        </p>
                        <p class="bag-item__accordion-value">
                          <span class="skeleton skeleton--text cart-skeleton__detail-value"></span>
                        </p>
                      </li>
                      <li class="bag-item__accordion-field">
                        <p class="bag-item__accordion-value">
                          <span class="skeleton skeleton--text cart-skeleton__detail-label"></span>
                        </p>
                        <p class="bag-item__accordion-value">
                          <span class="skeleton skeleton--text cart-skeleton__detail-value"></span>
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="bag-item__actions bag-item__actions--physical">
                <span class="skeleton cart-skeleton__qty"></span>
                <div class="bag-item__actions-links">
                  <div class="bag-item__actions-links__row">
                    <span class="skeleton skeleton--text cart-skeleton__action"></span>
                    <span class="skeleton skeleton--text cart-skeleton__action"></span>
                    <span class="skeleton skeleton--text cart-skeleton__action"></span>
                  </div>
                </div>
              </div>
              <section class="bag-item__options">
                <div class="cart-skeleton__delivery">
                  <span class="skeleton skeleton--text cart-skeleton__delivery-title"></span>
                  <div class="cart-skeleton__delivery-options">
                    <span class="skeleton cart-skeleton__radio"></span>
                    <span class="skeleton cart-skeleton__radio"></span>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </article>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CartSkeleton',
};
</script>
